"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconAddWizard = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M55.26 7.53a4 4 0 0 0-2.86-1.19H17.6a4 4 0 0 0-2.26.66 4.08 4.08 0 0 0-.6.49 4 4 0 0 0-1.19 2.86v49.26a4 4 0 0 0 4 4h36l.16-.05a4 4 0 0 0 2.73-3.81V10.39a4 4 0 0 0-1.18-2.86zm-4.31 4.31v46.32H19.06V11.84z"
  }), _react["default"].createElement("path", {
    d: "M24.74 37.6h7.66v7.66a2.6 2.6 0 0 0 5.19 0V37.6h7.66a2.6 2.6 0 1 0 0-5.19H37.6v-7.67a2.6 2.6 0 1 0-5.19 0v7.66h-7.67a2.6 2.6 0 1 0 0 5.19z"
  })),
  height: undefined,
  width: undefined
});
IconAddWizard.displayName = 'IconAddWizard';
var _default = IconAddWizard;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/add-wizard.js
// module id = 579
// module chunks = 0